export const DEMO_USER = {
  uid: "demo-user-001",
  email: "demo@organizeflow.app",
  displayName: "Demo User",
  emailVerified: true,
  providerData: [{ providerId: "password" }],
};

export const DEMO_PROFILE = [
  {
    id: 1,
    user_id: "demo-user-001",
    preferred_currency: "USD",
    email: "demo@organizeflow.app",
    full_name: "Demo User",
    created_at: "2026-01-01T00:00:00.000Z",
  },
];

export const DEMO_FX_RATES = {
  USD: 1,
  EUR: 0.92,
  GBP: 0.79,
  RON: 4.67,
  CHF: 0.9,
};

export const DEMO_CATEGORIES = [
  {
    id: 1,
    name: "Food",
    display_name: "Food",
    context_name: "Personal",
    type: "EXPENSE",
    color: "#FF5722",
    context_type: "personal",
    group_id: null,
  },
  {
    id: 2,
    name: "Transportation",
    display_name: "Transportation",
    context_name: "Personal",
    type: "EXPENSE",
    color: "#2196F3",
    context_type: "personal",
    group_id: null,
  },
  {
    id: 3,
    name: "Entertainment",
    display_name: "Entertainment",
    context_name: "Personal",
    type: "EXPENSE",
    color: "#9C27B0",
    context_type: "personal",
    group_id: null,
  },
  {
    id: 4,
    name: "Utilities",
    display_name: "Utilities",
    context_name: "Personal",
    type: "EXPENSE",
    color: "#FF9800",
    context_type: "personal",
    group_id: null,
  },
  {
    id: 5,
    name: "Shopping",
    display_name: "Shopping",
    context_name: "Personal",
    type: "EXPENSE",
    color: "#E91E63",
    context_type: "personal",
    group_id: null,
  },
  {
    id: 6,
    name: "Salary",
    display_name: "Salary",
    context_name: "Personal",
    type: "INCOME",
    color: "#4CAF50",
    context_type: "personal",
    group_id: null,
  },
  {
    id: 7,
    name: "Freelance",
    display_name: "Freelance",
    context_name: "Personal",
    type: "INCOME",
    color: "#8BC34A",
    context_type: "personal",
    group_id: null,
  },
  {
    id: 8,
    name: "Stocks",
    display_name: "Stocks",
    context_name: "Personal",
    type: "INVESTMENT",
    color: "#00BCD4",
    context_type: "personal",
    group_id: null,
  },
];

export const DEMO_TRANSACTIONS = [
  // Expenses
  {
    id: "d-t-1",
    date: "2026-04-28",
    amount: 45.5,
    currency: "USD",
    vendor: "Whole Foods",
    note: "Weekly groceries",
    category_id: 1,
    category_name: "Food",
    type: "expense",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-2",
    date: "2026-04-25",
    amount: 28.0,
    currency: "USD",
    vendor: "Shell Gas Station",
    note: "Fuel refill",
    category_id: 2,
    category_name: "Transportation",
    type: "expense",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-3",
    date: "2026-04-20",
    amount: 15.99,
    currency: "USD",
    vendor: "Netflix",
    note: "Monthly subscription",
    category_id: 3,
    category_name: "Entertainment",
    type: "expense",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-4",
    date: "2026-04-18",
    amount: 120.0,
    currency: "USD",
    vendor: "Electric Company",
    note: "April electricity bill",
    category_id: 4,
    category_name: "Utilities",
    type: "expense",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-5",
    date: "2026-04-15",
    amount: 89.99,
    currency: "USD",
    vendor: "Amazon",
    note: "Office supplies",
    category_id: 5,
    category_name: "Shopping",
    type: "expense",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-13",
    date: "2026-04-12",
    amount: 62.3,
    currency: "USD",
    vendor: "Trader Joe's",
    note: "Groceries",
    category_id: 1,
    category_name: "Food",
    type: "expense",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-14",
    date: "2026-04-08",
    amount: 45.0,
    currency: "USD",
    vendor: "Uber",
    note: "Rides this week",
    category_id: 2,
    category_name: "Transportation",
    type: "expense",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-15",
    date: "2026-04-05",
    amount: 14.99,
    currency: "USD",
    vendor: "Spotify",
    note: "Music subscription",
    category_id: 3,
    category_name: "Entertainment",
    type: "expense",
    context_type: "personal",
    group_id: null,
  },
  // Income
  {
    id: "d-t-6",
    date: "2026-04-30",
    amount: 4200.0,
    currency: "USD",
    vendor: "Tech Corp",
    note: "Monthly salary",
    category_id: 6,
    category_name: "Salary",
    type: "income",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-7",
    date: "2026-04-15",
    amount: 850.0,
    currency: "USD",
    vendor: "Client A",
    note: "Freelance web project",
    category_id: 7,
    category_name: "Freelance",
    type: "income",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-8",
    date: "2026-03-30",
    amount: 4200.0,
    currency: "USD",
    vendor: "Tech Corp",
    note: "March salary",
    category_id: 6,
    category_name: "Salary",
    type: "income",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-16",
    date: "2026-03-20",
    amount: 500.0,
    currency: "USD",
    vendor: "Client B",
    note: "Logo design project",
    category_id: 7,
    category_name: "Freelance",
    type: "income",
    context_type: "personal",
    group_id: null,
  },
  // Investments
  {
    id: "d-t-9",
    date: "2026-04-10",
    amount: 500.0,
    currency: "USD",
    vendor: "Interactive Brokers",
    note: "AAPL shares purchase",
    category_id: 8,
    category_name: "Stocks",
    type: "investment",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-10",
    date: "2026-03-25",
    amount: 1750.0,
    currency: "USD",
    vendor: "Interactive Brokers",
    note: "NVDA shares purchase",
    category_id: 8,
    category_name: "Stocks",
    type: "investment",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-11",
    date: "2026-03-10",
    amount: 877.5,
    currency: "USD",
    vendor: "Interactive Brokers",
    note: "AAPL initial position",
    category_id: 8,
    category_name: "Stocks",
    type: "investment",
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-t-12",
    date: "2026-02-20",
    amount: 1660.0,
    currency: "USD",
    vendor: "Interactive Brokers",
    note: "MSFT shares purchase",
    category_id: 8,
    category_name: "Stocks",
    type: "investment",
    context_type: "personal",
    group_id: null,
  },
];

export const DEMO_RECURRING = [
  {
    id: "d-r-1",
    start_date: "2026-01-01",
    frequency: "MONTHLY",
    next_due_date: "2026-05-15",
    end_date: null,
    category_id: 3,
    category_name: "Entertainment",
    category_type: "EXPENSE",
    amount: 15.99,
    currency: "USD",
    vendor: "Netflix",
    note: "",
    status: "active",
    number_of_payments: null,
    total_amount: null,
    is_permanent: true,
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-r-2",
    start_date: "2026-01-01",
    frequency: "MONTHLY",
    next_due_date: "2026-05-18",
    end_date: null,
    category_id: 4,
    category_name: "Utilities",
    category_type: "EXPENSE",
    amount: 120.0,
    currency: "USD",
    vendor: "Electric Company",
    note: "Monthly electricity bill",
    status: "active",
    number_of_payments: null,
    total_amount: null,
    is_permanent: true,
    context_type: "personal",
    group_id: null,
  },
  {
    id: "d-r-3",
    start_date: "2026-01-01",
    frequency: "MONTHLY",
    next_due_date: "2026-05-01",
    end_date: null,
    category_id: 3,
    category_name: "Entertainment",
    category_type: "EXPENSE",
    amount: 14.99,
    currency: "USD",
    vendor: "Spotify",
    note: "",
    status: "active",
    number_of_payments: null,
    total_amount: null,
    is_permanent: true,
    context_type: "personal",
    group_id: null,
  },
];

// Brokers — uses field names expected by BrokersPage
export const DEMO_BROKERS = [
  {
    id: 1,
    name: "Interactive Brokers",
    main_currency: "USD",
    holdings_count: 3,
    total_value: 3262.8,
    account_number: "DEMO-001",
    notes: "Main brokerage account",
  },
  {
    id: 2,
    name: "Robinhood",
    main_currency: "USD",
    holdings_count: 1,
    total_value: 1901.6,
    account_number: "",
    notes: "",
  },
];

// Holdings (stock transactions) — uses field names expected by HoldingsPage
export const DEMO_HOLDINGS = [
  {
    id: 1,
    ticker_symbol: "AAPL",
    company_name: "Apple Inc.",
    transaction_type: "BUY",
    quantity: 5,
    purchase_price: 175.5,
    total_cost: 877.5,
    purchase_date: "2026-03-10",
    currency: "USD",
    broker_id: 1,
    broker_name: "Interactive Brokers",
    exchange: "NASDAQ",
    fees: 0,
    notes: "AAPL initial position",
  },
  {
    id: 2,
    ticker_symbol: "AAPL",
    company_name: "Apple Inc.",
    transaction_type: "BUY",
    quantity: 3,
    purchase_price: 185.0,
    total_cost: 555.0,
    purchase_date: "2026-04-01",
    currency: "USD",
    broker_id: 1,
    broker_name: "Interactive Brokers",
    exchange: "NASDAQ",
    fees: 0,
    notes: "",
  },
  {
    id: 3,
    ticker_symbol: "NVDA",
    company_name: "NVIDIA Corporation",
    transaction_type: "BUY",
    quantity: 2,
    purchase_price: 875.0,
    total_cost: 1750.0,
    purchase_date: "2026-03-15",
    currency: "USD",
    broker_id: 2,
    broker_name: "Robinhood",
    exchange: "NASDAQ",
    fees: 0,
    notes: "",
  },
  {
    id: 4,
    ticker_symbol: "MSFT",
    company_name: "Microsoft Corporation",
    transaction_type: "BUY",
    quantity: 4,
    purchase_price: 415.0,
    total_cost: 1660.0,
    purchase_date: "2026-02-20",
    currency: "USD",
    broker_id: 1,
    broker_name: "Interactive Brokers",
    exchange: "NASDAQ",
    fees: 0,
    notes: "",
  },
];

// Stock prices — uses field names expected by PositionsPage (calculateGainLoss)
export const DEMO_STOCK_PRICES = {
  AAPL: {
    ticker_symbol: "AAPL",
    current_price: 195.2,
    price_change: 2.15,
    price_change_percent: 1.11,
    fifty_two_week_high: 237.23,
    fifty_two_week_low: 164.08,
    currency: "USD",
    name: "Apple Inc.",
  },
  NVDA: {
    ticker_symbol: "NVDA",
    current_price: 950.8,
    price_change: -8.4,
    price_change_percent: -0.88,
    fifty_two_week_high: 974.0,
    fifty_two_week_low: 462.22,
    currency: "USD",
    name: "NVIDIA Corporation",
  },
  MSFT: {
    ticker_symbol: "MSFT",
    current_price: 425.3,
    price_change: 3.2,
    price_change_percent: 0.76,
    fifty_two_week_high: 468.35,
    fifty_two_week_low: 369.0,
    currency: "USD",
    name: "Microsoft Corporation",
  },
};

// Positions — uses field names expected by PositionsPage and PortfolioOverviewPage
export const DEMO_POSITIONS = [
  {
    ticker_symbol: "AAPL",
    company_name: "Apple Inc.",
    net_quantity: 8,
    avg_price: 179.44,
    total_cost: 1435.5,
    current_value: 1561.6,
    unrealized_pl: 126.1,
    unrealized_pl_percent: 8.79,
    currency: "USD",
    broker_id: 1,
    broker_name: "Interactive Brokers",
    exchange: "NASDAQ",
  },
  {
    ticker_symbol: "NVDA",
    company_name: "NVIDIA Corporation",
    net_quantity: 2,
    avg_price: 875.0,
    total_cost: 1750.0,
    current_value: 1901.6,
    unrealized_pl: 151.6,
    unrealized_pl_percent: 8.66,
    currency: "USD",
    broker_id: 2,
    broker_name: "Robinhood",
    exchange: "NASDAQ",
  },
  {
    ticker_symbol: "MSFT",
    company_name: "Microsoft Corporation",
    net_quantity: 4,
    avg_price: 415.0,
    total_cost: 1660.0,
    current_value: 1701.2,
    unrealized_pl: 41.2,
    unrealized_pl_percent: 2.48,
    currency: "USD",
    broker_id: 1,
    broker_name: "Interactive Brokers",
    exchange: "NASDAQ",
  },
];

// Portfolio summary — uses structure expected by PortfolioOverviewPage
export const DEMO_PORTFOLIO_SUMMARY = {
  positions: DEMO_POSITIONS,
  overall: {
    total_cost: 4845.5,
    total_value: 5164.4,
    total_pl: 318.9,
    total_pl_percent: 6.58,
    total_positions: 3,
  },
  currencies: {
    "Interactive Brokers": "USD",
    Robinhood: "USD",
  },
};

const generatePortfolioHistory = () => {
  const history = [];
  const startValue = 4600;
  const startCost = 4200;
  const endValue = 5164;
  const endCost = 4845;
  for (let i = 0; i < 90; i++) {
    const date = new Date("2026-01-03");
    date.setDate(date.getDate() + i);
    const progress = i / 89;
    const trend = startValue + (endValue - startValue) * progress;
    const costTrend = startCost + (endCost - startCost) * progress;
    const noise = Math.sin(i * 0.5) * 80 + Math.cos(i * 0.3) * 50;
    history.push({
      date: date.toISOString().split("T")[0],
      total_value: parseFloat(
        Math.max(trend + noise, startValue * 0.95).toFixed(2),
      ),
      total_cost: parseFloat(costTrend.toFixed(2)),
      currency: "USD",
    });
  }
  return history;
};
export const DEMO_PORTFOLIO_HISTORY = generatePortfolioHistory();

export const DEMO_HOLDINGS_BY_BROKER = [
  {
    broker_id: 1,
    broker_name: "Interactive Brokers",
    currency: "USD",
    total_cost: 3095.5,
    current_value: 3262.8,
    pnl: 167.3,
    pnl_pct: 5.41,
    holdings: [
      { ticker_symbol: "AAPL", quantity: 8, current_value: 1561.6, pnl: 126.1 },
      { ticker_symbol: "MSFT", quantity: 4, current_value: 1701.2, pnl: 41.2 },
    ],
  },
  {
    broker_id: 2,
    broker_name: "Robinhood",
    currency: "USD",
    total_cost: 1750.0,
    current_value: 1901.6,
    pnl: 151.6,
    pnl_pct: 8.66,
    holdings: [
      { ticker_symbol: "NVDA", quantity: 2, current_value: 1901.6, pnl: 151.6 },
    ],
  },
];

// Position details — uses field names expected by PositionsPage expanded view
export const DEMO_ALL_POSITION_DETAILS = {
  "AAPL-1": [
    {
      id: 1,
      ticker_symbol: "AAPL",
      transaction_type: "BUY",
      quantity: 5,
      purchase_price: 175.5,
      total_cost: 877.5,
      purchase_date: "2026-03-10",
      currency: "USD",
      notes: "AAPL initial position",
    },
    {
      id: 2,
      ticker_symbol: "AAPL",
      transaction_type: "BUY",
      quantity: 3,
      purchase_price: 185.0,
      total_cost: 555.0,
      purchase_date: "2026-04-01",
      currency: "USD",
      notes: "",
    },
  ],
  "NVDA-2": [
    {
      id: 3,
      ticker_symbol: "NVDA",
      transaction_type: "BUY",
      quantity: 2,
      purchase_price: 875.0,
      total_cost: 1750.0,
      purchase_date: "2026-03-15",
      currency: "USD",
      notes: "",
    },
  ],
  "MSFT-1": [
    {
      id: 4,
      ticker_symbol: "MSFT",
      transaction_type: "BUY",
      quantity: 4,
      purchase_price: 415.0,
      total_cost: 1660.0,
      purchase_date: "2026-02-20",
      currency: "USD",
      notes: "",
    },
  ],
};

export const DEMO_TOTALS = {
  totalIncome: 9750.0,
  totalExpenses: 421.77,
  totalInvestments: 4787.5,
  totalSavings: 4540.73,
};

// Category breakdown charts — { income, expenses, investments, savings } with monthly arrays
// Used by CategoryChartsPage (getAllCategoryStats response shape)
export const DEMO_ALL_CATEGORY_STATS = {
  income: [
    { month: "Nov", year: 2025, amount: 4200 },
    { month: "Dec", year: 2025, amount: 5200 },
    { month: "Jan", year: 2026, amount: 4200 },
    { month: "Feb", year: 2026, amount: 4500 },
    { month: "Mar", year: 2026, amount: 4700 },
    { month: "Apr", year: 2026, amount: 5050 },
  ],
  expenses: [
    { month: "Nov", year: 2025, amount: 380.5 },
    { month: "Dec", year: 2025, amount: 620.3 },
    { month: "Jan", year: 2026, amount: 290.0 },
    { month: "Feb", year: 2026, amount: 350.0 },
    { month: "Mar", year: 2026, amount: 180.0 },
    { month: "Apr", year: 2026, amount: 421.77 },
  ],
  investments: [
    { month: "Dec", year: 2025, amount: 500 },
    { month: "Feb", year: 2026, amount: 1660 },
    { month: "Mar", year: 2026, amount: 2627.5 },
    { month: "Apr", year: 2026, amount: 500 },
  ],
  savings: [
    { month: "Nov", year: 2025, amount: 3819.5 },
    { month: "Dec", year: 2025, amount: 4079.7 },
    { month: "Jan", year: 2026, amount: 3910.0 },
    { month: "Feb", year: 2026, amount: 2490.0 },
    { month: "Mar", year: 2026, amount: 1892.5 },
    { month: "Apr", year: 2026, amount: 4128.23 },
  ],
};

// Per-category monthly breakdown — used by CategoryStatsChart (getCategoryStats response)
export const DEMO_CATEGORY_MONTHLY_STATS = {
  1: [
    // Food
    { month: "Nov", year: 2025, amount: 85.0 },
    { month: "Dec", year: 2025, amount: 95.5 },
    { month: "Jan", year: 2026, amount: 72.0 },
    { month: "Feb", year: 2026, amount: 110.0 },
    { month: "Mar", year: 2026, amount: 92.0 },
    { month: "Apr", year: 2026, amount: 107.8 },
  ],
  2: [
    // Transportation
    { month: "Nov", year: 2025, amount: 60.0 },
    { month: "Dec", year: 2025, amount: 55.0 },
    { month: "Jan", year: 2026, amount: 48.0 },
    { month: "Feb", year: 2026, amount: 65.0 },
    { month: "Mar", year: 2026, amount: 55.0 },
    { month: "Apr", year: 2026, amount: 73.0 },
  ],
  3: [
    // Entertainment
    { month: "Nov", year: 2025, amount: 30.98 },
    { month: "Dec", year: 2025, amount: 45.97 },
    { month: "Jan", year: 2026, amount: 30.98 },
    { month: "Feb", year: 2026, amount: 30.98 },
    { month: "Mar", year: 2026, amount: 30.98 },
    { month: "Apr", year: 2026, amount: 30.98 },
  ],
  4: [
    // Utilities
    { month: "Nov", year: 2025, amount: 105.0 },
    { month: "Dec", year: 2025, amount: 130.0 },
    { month: "Jan", year: 2026, amount: 115.0 },
    { month: "Feb", year: 2026, amount: 125.0 },
    { month: "Mar", year: 2026, amount: 0 },
    { month: "Apr", year: 2026, amount: 120.0 },
  ],
  5: [
    // Shopping
    { month: "Nov", year: 2025, amount: 148.53 },
    { month: "Dec", year: 2025, amount: 293.83 },
    { month: "Jan", year: 2026, amount: 25.0 },
    { month: "Feb", year: 2026, amount: 30.0 },
    { month: "Mar", year: 2026, amount: 0 },
    { month: "Apr", year: 2026, amount: 89.99 },
  ],
  6: [
    // Salary
    { month: "Nov", year: 2025, amount: 4200 },
    { month: "Dec", year: 2025, amount: 4200 },
    { month: "Jan", year: 2026, amount: 4200 },
    { month: "Feb", year: 2026, amount: 4200 },
    { month: "Mar", year: 2026, amount: 4200 },
    { month: "Apr", year: 2026, amount: 4200 },
  ],
  7: [
    // Freelance
    { month: "Dec", year: 2025, amount: 1000 },
    { month: "Feb", year: 2026, amount: 300 },
    { month: "Mar", year: 2026, amount: 500 },
    { month: "Apr", year: 2026, amount: 850 },
  ],
  8: [
    // Stocks
    { month: "Dec", year: 2025, amount: 500 },
    { month: "Feb", year: 2026, amount: 1660 },
    { month: "Mar", year: 2026, amount: 2627.5 },
    { month: "Apr", year: 2026, amount: 500 },
  ],
};

// Flat category stats list — used by demoGetCategoriesWithGroups (filter dropdown)
export const DEMO_CATEGORY_STATS_FLAT = [
  {
    category_id: 1,
    category_name: "Food",
    type: "EXPENSE",
    total: 562.3,
    count: 12,
    currency: "USD",
  },
  {
    category_id: 2,
    category_name: "Transportation",
    type: "EXPENSE",
    total: 356.0,
    count: 12,
    currency: "USD",
  },
  {
    category_id: 3,
    category_name: "Entertainment",
    type: "EXPENSE",
    total: 199.9,
    count: 12,
    currency: "USD",
  },
  {
    category_id: 4,
    category_name: "Utilities",
    type: "EXPENSE",
    total: 595.0,
    count: 5,
    currency: "USD",
  },
  {
    category_id: 5,
    category_name: "Shopping",
    type: "EXPENSE",
    total: 587.35,
    count: 6,
    currency: "USD",
  },
  {
    category_id: 6,
    category_name: "Salary",
    type: "INCOME",
    total: 25200.0,
    count: 6,
    currency: "USD",
  },
  {
    category_id: 7,
    category_name: "Freelance",
    type: "INCOME",
    total: 2650.0,
    count: 4,
    currency: "USD",
  },
  {
    category_id: 8,
    category_name: "Stocks",
    type: "INVESTMENT",
    total: 5287.5,
    count: 4,
    currency: "USD",
  },
];

export const DEMO_EXPENSES_BY_CATEGORY = [
  {
    category_id: 1,
    category: "Food",
    total: 107.8,
    percentage: 25.6,
    count: 2,
    currency: "USD",
  },
  {
    category_id: 2,
    category: "Transportation",
    total: 73.0,
    percentage: 17.3,
    count: 2,
    currency: "USD",
  },
  {
    category_id: 3,
    category: "Entertainment",
    total: 30.98,
    percentage: 7.3,
    count: 2,
    currency: "USD",
  },
  {
    category_id: 4,
    category: "Utilities",
    total: 120.0,
    percentage: 28.5,
    count: 1,
    currency: "USD",
  },
  {
    category_id: 5,
    category: "Shopping",
    total: 89.99,
    percentage: 21.3,
    count: 1,
    currency: "USD",
  },
];

export const DEMO_INCOME_BY_CATEGORY = [
  {
    category_id: 6,
    category: "Salary",
    total: 8400.0,
    percentage: 90.8,
    count: 2,
    currency: "USD",
  },
  {
    category_id: 7,
    category: "Freelance",
    total: 850.0,
    percentage: 9.2,
    count: 2,
    currency: "USD",
  },
];

export const DEMO_TOP_EXPENSES = [
  { vendor: "Electric Company", total: 120.0, count: 1, currency: "USD" },
  { vendor: "Amazon", total: 89.99, count: 1, currency: "USD" },
  { vendor: "Trader Joe's", total: 62.3, count: 1, currency: "USD" },
  { vendor: "Whole Foods", total: 45.5, count: 1, currency: "USD" },
  { vendor: "Uber", total: 45.0, count: 1, currency: "USD" },
];

export const DEMO_UPCOMING_RECURRING = [
  {
    id: "d-r-3",
    vendor: "Spotify",
    amount: 14.99,
    next_due_date: "2026-05-01",
    frequency: "MONTHLY",
    category_name: "Entertainment",
    currency: "USD",
  },
  {
    id: "d-r-1",
    vendor: "Netflix",
    amount: 15.99,
    next_due_date: "2026-05-15",
    frequency: "MONTHLY",
    category_name: "Entertainment",
    currency: "USD",
  },
  {
    id: "d-r-2",
    vendor: "Electric Company",
    amount: 120.0,
    next_due_date: "2026-05-18",
    frequency: "MONTHLY",
    category_name: "Utilities",
    currency: "USD",
  },
];

export const DEMO_STOCK_FUNDAMENTALS = {
  AAPL: {
    ticker: "AAPL",
    name: "Apple Inc.",
    sector: "Technology",
    industry: "Consumer Electronics",
    market_cap: 3020000000000,
    pe_ratio: 33.2,
    eps: 5.88,
    dividend_yield: 0.44,
    beta: 1.19,
    week_52_high: 237.23,
    week_52_low: 164.08,
    description:
      "Apple Inc. designs, manufactures, and markets smartphones, personal computers, tablets, wearables, and accessories worldwide.",
  },
  NVDA: {
    ticker: "NVDA",
    name: "NVIDIA Corporation",
    sector: "Technology",
    industry: "Semiconductors",
    market_cap: 2340000000000,
    pe_ratio: 55.8,
    eps: 17.04,
    dividend_yield: 0.03,
    beta: 2.02,
    week_52_high: 974.0,
    week_52_low: 462.22,
    description:
      "NVIDIA Corporation provides graphics, compute and networking solutions worldwide.",
  },
  MSFT: {
    ticker: "MSFT",
    name: "Microsoft Corporation",
    sector: "Technology",
    industry: "Software—Infrastructure",
    market_cap: 3160000000000,
    pe_ratio: 37.4,
    eps: 11.38,
    dividend_yield: 0.72,
    beta: 0.88,
    week_52_high: 468.35,
    week_52_low: 369.0,
    description:
      "Microsoft Corporation develops and supports software, services, devices, and solutions worldwide.",
  },
};

const generatePriceHistory = (ticker, currentPrice) => {
  const volatility = { AAPL: 0.012, NVDA: 0.022, MSFT: 0.01 }[ticker] || 0.015;
  let price = currentPrice * 0.78;
  const history = [];
  for (let i = 365; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    const change = price * volatility * (Math.random() - 0.44);
    price = Math.max(price + change, currentPrice * 0.5);
    history.push({
      date: date.toISOString().split("T")[0],
      close: parseFloat(price.toFixed(2)),
      open: parseFloat((price * 0.998).toFixed(2)),
      high: parseFloat((price * 1.006).toFixed(2)),
      low: parseFloat((price * 0.994).toFixed(2)),
      volume: Math.floor(Math.random() * 50000000 + 30000000),
    });
  }
  return history;
};

export const DEMO_PRICE_HISTORY = {
  AAPL: generatePriceHistory("AAPL", 195.2),
  NVDA: generatePriceHistory("NVDA", 950.8),
  MSFT: generatePriceHistory("MSFT", 425.3),
};

export const DEMO_STOCK_NEWS = {
  AAPL: [
    {
      title: "Apple Beats Q2 Earnings Estimates with Strong iPhone Sales",
      published: "2026-04-30",
      source: "Reuters",
      url: "#",
    },
    {
      title: "Apple Vision Pro Sales Exceed Expectations in First Quarter",
      published: "2026-04-22",
      source: "Bloomberg",
      url: "#",
    },
    {
      title: "Apple Announces New AI Features for iOS 20",
      published: "2026-04-15",
      source: "TechCrunch",
      url: "#",
    },
  ],
  NVDA: [
    {
      title: "NVIDIA Reports Record Data Center Revenue for Q1 2026",
      published: "2026-04-28",
      source: "CNBC",
      url: "#",
    },
    {
      title: "NVIDIA H200 GPUs See Massive Demand from Cloud Providers",
      published: "2026-04-20",
      source: "Reuters",
      url: "#",
    },
    {
      title: "NVIDIA Partners with Leading AI Companies for Next-Gen Chips",
      published: "2026-04-12",
      source: "Bloomberg",
      url: "#",
    },
  ],
  MSFT: [
    {
      title: "Microsoft Azure Revenue Grows 33% Year-Over-Year",
      published: "2026-04-29",
      source: "Wall Street Journal",
      url: "#",
    },
    {
      title: "Microsoft Copilot Reaches 100 Million Daily Active Users",
      published: "2026-04-18",
      source: "TechCrunch",
      url: "#",
    },
    {
      title: "Microsoft Teams Integrations Expand Enterprise AI Capabilities",
      published: "2026-04-10",
      source: "The Verge",
      url: "#",
    },
  ],
};
